import React, { useState } from "react";

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Quelle est la différence entre le Bootcamp et le Tutorat ?",
      answer:
        "Le Bootcamp est un programme intensif sur une courte période, idéal pour progresser rapidement. Le Tutorat, quant à lui, est un accompagnement plus flexible et personnalisé dans la durée."
    },
    {
      question: "Puis-je suivre le Tutorat à distance ?",
      answer:
        "Oui, le Tutorat est disponible à distance grâce à notre plateforme en ligne. Vous pouvez échanger avec votre tuteur où que vous soyez."
    },
    {
      question: "Est-ce adapté si je n’ai pas encore d’expérience en fabrication numérique ?",
      answer:
        "Absolument ! Nos programmes sont conçus pour accueillir les débutants. Vous serez accompagné pas à pas, même sans expérience préalable."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h2 className="text-title font-bold text-dark-1 mb-4 text-center">
          Questions fréquentes
        </h2>
        <p className="text-gray-600 mb-10 text-center text-subtitle">
          Retrouvez ici les réponses aux questions que l’on nous pose le plus souvent.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-dark-1 rounded-2xl shadow-lg overflow-hidden transition"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex justify-between items-center px-6 py-4 text-left"
              >
                <span className="font-semibold text-white">{faq.question}</span>
                <svg
                  className={`w-5 h-5 transform transition-transform text-white ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-gray-100">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
